import { render, staticRenderFns } from "./Signatario.vue?vue&type=template&id=10531d8c"
import script from "./Signatario.vue?vue&type=script&lang=js"
export * from "./Signatario.vue?vue&type=script&lang=js"
import style0 from "./Signatario.vue?vue&type=style&index=0&id=10531d8c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports